import React from 'react';
import {View, Pressable, Platform} from 'react-native';
import moment from 'moment';

import Text from '../../elements/Text';
import CachedImage from '../../elements/CachedImage';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';

const RecommendedResourceCard = ({
  item,
  index,
  refreshMainList,
  navigation,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Pressable
      testID={tID(
        `RecommendedResourceCard-Pressable-CardConatiner${index + 1}`,
      )}
      style={styles.container(index === 0 ? 0 : 16)}
      onPress={() => {
        if (Platform.OS === 'web') {
          navigation('/resource-details', {
            state: {
              data: item,
              recommended: true,
            },
          });
        } else {
          navigation.navigate('ViewResource', {
            data: item,
            refreshMainList: refreshMainList,
          });
        }
      }}>
      <View>
        <CachedImage source={item.heroImage} style={styles.image} />
        <View style={styles.tagContainer}>
          <Text
            testID={tID(`RecommendedResourceCard-Text-Tag${index + 1}`)}
            variation="Text1SemiBold"
            color={colors.link}>
            {item.articleCategoryLink.length > 0
              ? item.articleCategoryLink[0].articleCategory.name
              : ''}
          </Text>
        </View>
      </View>
      <View style={styles.content}>
        <Text
          testID={tID(`RecommendedResourceCard-Text-Title${index + 1}`)}
          style={styles.applyFlex}
          numberOfLines={2}
          variation="Subtitle1SemiBold"
          color={colors.textPrimary}>
          {item.title}
        </Text>
        <Text
          testID={tID(`RecommendedResourceCard-Text-Author${index + 1}`)}
          variation="Text2Medium"
          color={colors.textMuted}
          topMargin={12}>
          {item.articleAuthorLink.length > 0
            ? item.articleAuthorLink[0].articleAuthor.name
            : ''}{' '}
          • {moment(item.published).fromNow()}
        </Text>
      </View>
    </Pressable>
  );
};

export default RecommendedResourceCard;
